import React from "react";

const TiktokSliderSkeleton: React.FC = () => {
  return (
    <div>
      {/* tiktok slider section */}
      <section className="py-14 bg-[url('@assets/images/PhoneBG1.webp')] bg-no-repeat bg-center bg-cover max-xl:pt-12 max-md:py-10 max-sm:py-6 px-4">
        <div className="px-20 max-xl:px-10 grid items-center grid-cols-3 max-md:grid-cols-1 gap-4 max-lg:px-0">
          <div className="max-2xl:col-span-3 flex flex-col gap-3">
            <span className="bg-gray-300 h-20 w-80 max-md:h-14 max-md:w-72 rounded-xl skeleton block"></span>
            <span className="bg-gray-300 h-20 w-80 max-md:h-14 max-md:w-72 rounded-xl skeleton block"></span>
            <span className="bg-gray-300 h-20 w-80 max-md:h-14 max-md:w-72 rounded-xl skeleton block"></span>
          </div>
          <div className="flex overflow-hidden w-full 2xl:col-span-2 col-span-3 gap-4">
            <div className="skeleton shrink-0 number-slide1 relative border-[14px] border-[#222] overflow-hidden h-[560px] w-72 !rounded-[50px] after:absolute after:block after:top-0 after:left-2/4 after:-translate-x-2/4 after:rounded-b-xl after:h-6 after:w-32 after:bg-[#222]"></div>
            <div className="skeleton shrink-0 number-slide1 relative border-[14px] border-[#222] overflow-hidden h-[560px] w-72 !rounded-[50px] after:absolute after:block after:top-0 after:left-2/4 after:-translate-x-2/4 after:rounded-b-xl after:h-6 after:w-32 after:bg-[#222]"></div>
            <div className="skeleton shrink-0 number-slide1 relative border-[14px] border-[#222] overflow-hidden h-[560px] w-72 !rounded-[50px] after:absolute after:block after:top-0 after:left-2/4 after:-translate-x-2/4 after:rounded-b-xl after:h-6 after:w-32 after:bg-[#222]"></div>
            <div className="skeleton shrink-0 number-slide1 relative border-[14px] border-[#222] overflow-hidden h-[560px] w-72 !rounded-[50px] after:absolute after:block after:top-0 after:left-2/4 after:-translate-x-2/4 after:rounded-b-xl after:h-6 after:w-32 after:bg-[#222]"></div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TiktokSliderSkeleton;
